<mat-dialog-content>
	<div class="searchWrapper mt-2 flex flex-shrink-0 flex-col justify-stretch">
		<div class="searchInput flex flex-col items-start justify-center px-2">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-compact mat-form-field-no-hint w-full"
			>
				<input
					[formControl]="searchinput"
					cdkFocusInitial
					ignoreAutocomplete
					matInput
					tabindex="0"
					type="text"
				>
				<mat-icon
					inline
					matSuffix
				>
					search
				</mat-icon>
			</mat-form-field>
		</div>
		<div class="searchContainer pos-relative flex flex-col">
			<app-loader
				[enableCircle]="true"
				[isActive]="this.isLoading$ | async"
				[width]="20"
			></app-loader>
			<mat-list
				dense
				role="listbox"
			>
				<ng-container
					*ngFor="let entry of this.data$filtered | async; let last = last; let first = first; trackBy: trackFiltered"
				>
					<div
						[matTooltip]="entry.selected ? null : entry.exists ? ('errors.duplicatenames' | translate) : null"
					>
						<mat-list-item
							(click)="this.selectItem(entry)"
							(keyup.enter)="this.selectItem(entry)"
							[disabled]="entry.disabled"
							class="cursor-pointer truncate"
							matRipple
						>
							<div class="flex items-center space-x-2 truncate">
								<div
									[ngClass]="{
                    radio: true,
                    active: entry.selected,
                    disabled: entry.disabled,
                  }"
								></div>
								<div
									[matTooltip]="'client.color' | translate"
									[style.backgroundColor]="clientDisplayColor(entry)"
									class="project-color-dot flex-shrink-0 self-center"
								></div>
								<span class="truncate"> {{ entry.name }}</span>
							</div>
						</mat-list-item>
					</div>
					<mat-divider *ngIf="!last"></mat-divider>
				</ng-container>
			</mat-list>
		</div>
	</div>
	<div class="flex-auto"></div>
	<div class="flex flex-col items-stretch justify-end">
		<div class="flex flex-col">
			<button
				(click)="this.createDialog()"
				[disabled]="!(workspace$createPermission | async)"
				class="mat-button-filled entry-create-button"
				color="primary"
				mat-flat-button
				tabindex="0"
			>
				{{ 'client.create' | translate }}
			</button>
		</div>
	</div>
</mat-dialog-content>
